module.exports = __webpack_public_path__ + "static/media/fingerCircle.7e254c7a.svg";